<template>
  <v-dialog
    v-model="show"
    :fullscreen="isFullScreen"
    :persistent="isLoading"
    transition="dialog-bottom-transition"
    scrollable
    :width=" isFullScreen ? '' : '600px'"
  >
    <template v-slot:activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <v-card>
      <!--
        Card Title is important here to prevent the toolbar stretching in height
        when using fullscreen & scrollable attributes (in mobile).

        The scrollable attributes depends on heights being set. The toolbar height adjusts dynamically
        while the card-title is fixed
       -->
      <v-card-title class="pa-0 mb-3">
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            v-if="isFullScreen"
            icon
            dark
            :disabled="isLoading"
            @click="show = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title
            v-if="!isFullScreen"
            class="accent--text headline"
          >
            {{ title }}
          </v-toolbar-title>
          <div class="flex-grow-1" />
          <v-toolbar-items>
            <v-btn
              v-if="isFullScreen"
              text
              :loading="isLoading"
              @click="doAction()"
            >
              {{ actionName }}
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
      </v-card-title>

      <v-card-text>
        <slot name="content" />
      </v-card-text>

      <v-divider v-if="!isFullScreen" />

      <v-card-actions v-if="!isFullScreen">
        <v-spacer />
        <v-btn
          text
          outlined
          rounded
          :disabled="isLoading"
          @click="show = false"
        >
          {{ cancelName }}
        </v-btn>
        <v-btn
          outlined
          rounded
          :loading="isLoading"
          :disabled="isLoading"
          color="primary"
          @click="doAction()"
        >
          {{ actionName }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    action: {
      type: Function,
      default: () => () => {
      }
    },
    actionName: {
      type: String,
      default: ''
    },
    cancelName: {
      type: String,
      default: 'Cancel'
    },
    close: {
      type: Function,
      default: () => () => {
      }
    }
  },
  data() {
    return {
      dialog: false,
      isLoading: false
    }
  },
  computed: {
    isFullScreen() {
      return this.$vuetify.breakpoint.mdAndDown
    },
    show: {
      get() {
        return this.dialog
      },
      set(value) {
        if (!value) {
          this.doClose()
        }

        this.dialog = !!value
      }
    }
  },
  methods: {
    doClose() {
      this.close()
    },
    async doAction() {
      this.isLoading = true

      await this.action()
        .then(res => {
          console.log('action success?')
          this.show = false
        })
        .catch(e => {
          console.log('action failed')
          this.show = true
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
